// extracted by mini-css-extract-plugin
export var body = "tout-module--body--bKJ4Z";
export var contentPosition = "tout-module--contentPosition--w7pz4";
export var title = "tout-module--title--btup8";
export var topPadding = "tout-module--topPadding--DM01p";
export var videoContainer = "tout-module--videoContainer--R9RFC";
export var videoContainerMobile = "tout-module--videoContainerMobile--baWJp";